module.exports = __webpack_public_path__ + "9ab21017a1e4745adac96bfcd64be2a0.svg";